<template>
    <div class="modal-card">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered">
                Ultimos archivos subidos
            </h3>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')" />
        </header>
        <section class="modal-card-body">
            <div v-if="getFileTypes != 0" class="px-6">
                <p class="mb-5 is-size-4">Lista de archivos</p>
                <div v-for="(keyFile) in getFileTypes" :key="keyFile" class="mt-6">
                    <div class="columns is-mobile is-multiline is-vcentered mb-2">
                        <strong class="column is-8-mobile is-three-quarters-tablet is-size-5 is-align-content-start">{{
                            keyFile.toUpperCase() }}</strong>
                        <strong class="column is-align-items-end">Subido el:</strong>
                    </div>
                    <div v-for="(file, iFiles) in files[keyFile]" :key="file.drive_id"
                        class="columns is-mobile is-multiline is-vcentered pl-3 mb-2">
                        <div class="column is-8-mobile is-three-quarters-tablet is-align-content-start has-text-left">
                            <p class="">
                                {{ iFiles + 1 }}.-
                                <a @click="downloadFile(file.id_uploaded_file, keyFile, iFiles)">{{
                                    file.filename.toLowerCase() }}</a>
                            </p>
                            <progress v-if="loading[keyFile][iFiles]" class="progress is-small is-primary" max="100"
                                disabled>10%</progress>
                        </div>
                        <div class="column is-4-mobile is-align-content-end">
                            {{ moment(file.uploaded_date).format("DD MMMM YYYY") }}
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="getFileTypes == 0" class="px-6">
                <p class="mb-5 is-size-4">Aun no existen archivos subidos</p>
                <div class="mt-6">
                    <div class="columns is-mobile is-multiline is-vcentered mb-2">
                        <strong class="column is-8-mobile is-three-quarters-tablet is-size-5 is-align-content-start">
                            Aqui veras los ultimos archivos que subiste
                        </strong>
                    </div>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
            <button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>
        </footer>
    </div>
</template> 


<script>

import { getUrlsDownloadFile } from "@/api/uploadFiles";
import moment from "moment";

export default {
    name: "HistoricFiles",
    data() {
        return {
            loading: null,
        };
    },
    methods: {
        moment(date) {
            return moment(date);
        },
        downloadFile(idDownloadFile, keyFile, posFile) {
            this.updateLoading(keyFile, posFile, true)
            getUrlsDownloadFile(idDownloadFile)
                .then(({ data }) => {
                    let url = data.url_download
                    url = url.match(/^https?:/) ? url : '//' + url;
                    window.open(url)
                })
                .finally(() => {
                    this.updateLoading(keyFile, posFile, false)
                })
        },
        initLoading() {
            this.loading = {}
            Object.keys(this.files).map((key) => {
                let aux = {}
                aux[key] = []
                this.loading = {
                    ...this.loading,
                    ...aux,
                }

                this.files[key].map(() => {
                    this.loading[key] = [...this.loading[key], false]
                })
            })
        },
        updateLoading(fileType, posLoading, newValue) {
            this.loading[fileType].splice(posLoading, 1, newValue)
            this.loading = {
                ...this.loading
            }
        }
    },
    computed: {
        getFileTypes() {
            return Object.keys(this.files);
        },
    },
    created() {
        this.initLoading()
    },
    props: [
        "files",
    ]
};
</script>